<template>
  <div ref="splide" class="relative flex w-full items-center justify-start mb-4" v-if="products && loaded">
    <div class="relative flex mr-4 bg-success" style="width: 40px; height: 300px;">
      <div class="absolute text-xl text-white text-center" style="width: 300px; top: 0px; right: 8px; transform: rotate(-90deg) translate(0, -100%); transform-origin: 100% 0;"><b>{{ title }}</b></div>
    </div>
    <div class="relative flex pt-2">
      <splide :options="options">
        <splide-slide v-for="product in products" :key="product.id">
          <div class="relative overflow-hidden bg-white p-3 items-center justify-center text-center cursor-pointer" style="height: 280px;" @click="onClick(product)">
            <div class="absolute bg-success px-10 py-2 text-white text-bold text-center" style="width: 170px; top: 25px; left: -45px; transform: rotate(-45deg);" v-show="product.onSale"><b>Antes Q{{ product.originalPrice }}</b></div>
            <img :src="getImage(product, imageHeight)" alt="product.name" :height="imageHeight">
            <div>{{ product.name }}</div>
            <div class="text-warning text-xl"><b>Q{{ product.price.toFixed(2) }}</b></div>
          </div>
        </splide-slide>
      </splide>
    </div>
    <vs-popup :title="item.name" :active.sync="showProduct">
      <div class="flex w-full flex-col sm:flex-row">
        <div class="flex w-full md:w-1/5 items-center justify-center p-4" v-if="item.id > 0">
          <img :src="getImage(item, imageHeight)" alt="item.name" :height="imageHeight">
        </div>
        <div class="flex flex-col w-full md:w-4/5 items-center justify-between p-4">
          <div v-for="version in item.versionIds" :key="version.id">{{ version.name }}</div>
          <div class="text-2xl text-warning mb-2"><b>Q{{ item.price.toFixed(2) }}</b></div>
          <vs-spacer/>
          <div class="flex w-full justify-center sm:justify-end items-end sm:items-center">
            <vs-button icon-pack="feather" icon="icon-info" class="mr-2" @click="viewProduct">Ver detalle</vs-button>
            <vs-button
              v-if="isInCart(item.id)"
              class="bg-warning"
              icon-pack="feather"
              icon="icon-shopping-cart"
              color="success"
              @click="viewOrder">
              VER EN PEDIDO
            </vs-button>
            <vs-button
              class="bg-success"
              icon-pack="feather"
              icon="icon-shopping-cart"
              v-if="!isInCart(item.id) && item.status == 'ACT'"
              @click="toggleItemInCart">
              AGREGAR
            </vs-button>

          </div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
  import '@splidejs/splide/dist/css/themes/splide-default.min.css';

  export default {
    props: {
      list: {
        products: [],
        title: ''
      }
    },
    data () {
      return {
        loaded: false,
        options: {
          type: 'loop',
          width: 190,
          height: this.imageHeight,
          autoplay: true,
          interval: 15000,
          pauseOnHover: true,
          rewind: true,
          speed: 5000,
          gap: '0.5rem',
          perPage: 5,
          pagination: false,
          breakpoints: {
            320: {
              gap: '1rem',
              perPage: 1,
              width: 180
            },
            375: {
              gap: '0.5rem',
              perPage: 1,
              width: 280
            },
            420: {
              gap: '0.5rem',
              perPage: 2,
              width: 320
            },
            570: {
              gap: '1rem',
              perPage: 2,
              width: 380
            },
            768: {
              gap: '1rem',
              perPage: 3,
              width: 480
            },
            960: {
              gap: '1rem',
              perPage: 3,
              width: 700
            },
            1024: {
              gap: '1rem',
              perPage: 3,
              width: 920
            },
            1366: {
              gap: '1rem',
              perPage: 5,
              width: 1200
            },
            9999: {
              gap: '1rem',
              perPage: 6,
              width: 1300
            }
          }
        },
        showProduct: false,
        item: {
          id: 0,
          name: '',
          description: '',
          price: 0,
          versionIds: []
        }
      }
    },
    computed: {
      windowWidth() {
        return this.$store.state.windowWidth;
      },
      elementWidth() {
        if (this.windowWidth < 400) {
          return 100;
        } else if (this.windowWidth < 600) {
          return 150;
        } else {
          return 1100;
        }
      },
      imageHeight() {
        if (this.windowWidth < 400) {
          return 180;
        } else if (this.windowWidth < 600) {
          return 180;
        } else {
          return 200;
        }
      },
      imagesURL() {
        return this.$store.getters['getParameter']('images').baseURL;
      },
      title() {
        if (this.list) {
          return this.list.title;
        } else {
          return '';
        }
      },
      products() {
        if (this.$store.getters.fullProductsList) {
          if (typeof this.list.products == 'string') {
            const productIds = this.list.products.split(',');
            if (productIds.length > 0) {
              return [...this.$store.getters.fullProductsList].filter(function (product) {
                return productIds.includes(product.id.toString());
              });
            } else {
              return [];
            }
          } else {
            return this.list.products;
          }
        }
      },
      isInCart() {
        return (itemId) => this.$store.getters['eCommerce/isInCart'](itemId);
      }
    },
    methods: {
      getImage(item, height) {
        return [this.imagesURL, '/products%2F', item.id, '@', height, '.png?alt=media'].join('');
      },
      onClick(item) {
        this.item = {...item};
        this.showProduct = true;
      },
      viewProduct() {
        this.showProduct = false;
        this.$router.push({name: 'item-detail-view', params: {item: this.item.id}});
      },
      toggleItemInCart() {
        this.$store.dispatch('eCommerce/toggleItemInCart', this.item);
      },
      viewOrder() {
        this.showProduct = false;
        this.$router.push({name: 'checkout'});
      }
    },
    mounted() {
      var self = this;
      setTimeout(function () {
        self.loaded = true;
      }, 500);
    }
  }

</script>
